import * as roleApi from './api/index';
import Modal from './modal';
console.log(roleApi);
interface Configs {
  game: string,
  site?: string,
  loginType: LoginType
  allowPlatForm: LoginType[]
  appid: string
  // isAuto: boolean
}
interface RoleInfo {
  acctype: LoginType
  area: number
  characName: string
  characNo: string
  partition: string
  platid: string
}


interface GetRoleRsp {
  hasRole: boolean
  roleInfo?: RoleInfo
  errInfo?: any
}

class SlugRoleSelector {
  public game: string;
  public site: string;
  public appid: string;
  public loginType: LoginType;
  public serverSelect: ServerSelect | undefined;
  public isLoading = false;
  public isAuto = false;
  public modal = new Modal(this as SlugRoleSelectorClass)
  public allowPlatForm: LoginType[]
  public constructor(configs: Configs) {
    this.game = configs.game;
    this.site = configs.site || configs.game;
    this.loginType = configs.loginType;
    this.allowPlatForm =  configs.allowPlatForm;
    this.appid =  configs.appid || 'wxa817069bb040f860';
    // this.isAuto = configs.isAuto;
  }
  public afterBind?: Function = () => {}
  public afterQuery?: Function = () => {}
  public afterUnBind?: Function = () => {}

  public getRole(): Promise<GetRoleRsp> {
    const params = {
      site: this.site,
      loginType: this.loginType,
      game: this.game,
    };
    return this.getAuth()
      .then((isAuth: Boolean) => {
        if (isAuth) {
          this.modal.isAuth = true;
          return roleApi.getRole(params);
        }
        throw 'no auth';
      })
      .catch((err) => {
        console.warn(err);
        return Promise.reject({
          isAuth: false,
          hasRole: false,
          errInfo: err,
        });
      });
  }

  public getAuth() {
    const verifyType = this.loginType === 'qq' ? 'qqconnect' : 'wx_at';
    return roleApi.getAuth(verifyType, this.appid).then((res) => {
      const { attrs } = res;
      const isAuth = attrs.find((attr: any) => {
        console.log(this.site);
        if (attr.key === this.site && attr.i32 === 1) return true;
        return false;
      });
      return Boolean(isAuth);
    })
      .catch((err) => {
        console.error(err);
        return false;
      });
  }

  public setAuth(value: 0 | 1) {
    const verifyType = this.loginType === 'qq' ? 'qqconnect' : 'wx_at';
    return roleApi.setAuth(verifyType, this.site, value, this.appid);
  }

  public queryRole(area: number | '', platid: 1 | 0 | '', partition: number | '') {
    const params = {
      site: this.site,
      loginType: this.loginType,
      area,
      platid,
      partition,
    };
    return roleApi.queryRole(params);
  }
  public bindRole(token: string) {
    const params = {
      site: this.site,
      loginType: this.loginType,
      token,
    };
    return roleApi.bindRole(params);
  }
  public unBindRole() {
    return roleApi.unBindRole(this.site, this.loginType);
  }
  public showModal() {
    if (this.serverSelect) {
      this.modal.creatModal(this.serverSelect);
    } else {
      this.getServerSelect().then((res) => {
        if (!res.STD_DATA || !res.STD_CHANNEL_DATA) {
          alert('区服信息拉取失败，请稍后再试');
          return;
        }
        this.serverSelect = res;
        this.modal.creatModal(res);
        // , this as SlugRoleSelectorClass
      })
        .catch((err) => {
          console.log(err);
          alert('区服信息拉取失败，请稍后再试');
        });
    }
  }
  public hideModal() {
    this.modal.hideModal();
  }
  public getServerSelect() {
    return roleApi.getSelectJson(this.game, this.allowPlatForm);
  }
};

(window as any).SlugRoleSelector = SlugRoleSelector;
export default SlugRoleSelector;
// site: `txy_${GAME}`,
// game: GAME,
// allowPlatForm: ['wx', 'qq'],
// loginType: 'wx'


// interface GetRoleParams {
//   game: string
//   bid?: string
// }
// interface QueryRoleParams {
//   game: string
//   platid: 0| 1 // 平台（platid）IOS（0），安卓（1）
//   area: 1 | 2 // 渠道（area）微信1，手Q2
//   appid: string
//   // amsAcctype: 'wx' | 'qq' // platid
//   loginType: 'slug'
//   partition: string // 小区
//   partName: string // 小区名称,用于记录
// }
// interface BindRoleParams {
//   game: string
//   bid?: string
//   roleid: string
//   roleName: string // 用于记录
//   platid: 0| 1 // 平台（platid）IOS（0），安卓（1）
//   acctype: 1 | 2 // 渠道（area）微信1，手Q2
//   area: 1 | 2 // 渠道（area）微信1，手Q2
//   appid: string
//   // amsAcctype: 'wx' | 'qq' // platid
//   loginType: 'slug'
//   partition: string // 小区
//   partName: string // 小区名称,用于记录
// }

// interface SlugRoleSelector {
//   config(params: ConfigParams): void
//   showModal(): void
//   hideModal(): void
//   getRole(params?: GetRoleParams): Promise<any>
//   queryRole(params?: QueryRoleParams): Promise<any>
//   bindRole(params: BindRoleParams): Promise<any>
// }
